/* BaseActivityViewColumnComponent.js */

"use strict";

const DefaultColumnComponent = require("@gluenetworks/steve_ui_widgets").GridGl.DefaultColumnComponent;
const _ = require("lodash");

class BaseActivityViewColumnComponent extends DefaultColumnComponent {
    constructor(activityEntity) {
        super(activityEntity);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    shutdown() {
        this._unregisterListeners();
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    _normalizeCreateActivity(activityEntity) {
        let activity = {};
        _.set(activity, "activityType.activityType", "note");
        _.set(activity, "description.description", `File created by user (${activityEntity.createdBy}).`);
        _.set(activity, "status", "clean");
        return activity;
    }

    _normalizeUpdateActivity(activityEntity) {
        let patch = activityEntity.getProperty("patch");
        if (!patch || _.isEmpty(patch)) {
            return;
        }
        let description;
        let updatedBy = _.get(_.find(patch, { path: "/updatedBy" }), "value", _.get(activityEntity, "before.updatedBy", "system"));
        let activityType = updatedBy === "system" ? "system" : "note";
        let activityStatus = "clean";

        let status = _.get(_.find(patch, { path: "/status" }), "value");
        let errorMsg = _.get(_.find(patch, { path: "/lastErrorMsg" }), "value");

        switch (status) {
            case "UPLOADING":
                description = `File Uploading in progress.`;
                activityStatus = "running";
                break;
            case "UPLOADED":
                description = "File Uploaded.";
                activityStatus = "success";
                break;
            case "SYNCING":
                description = `File is Syncing.`;
                activityStatus = "running";
                break;
            case "READY":
                description = `File is Ready.`;
                activityStatus = "success";
                break;
            case "ERROR":
                description = `File Error. (${errorMsg})`;
                activityStatus = "failed";
                break;
            default:
                description = `File updated by ${updatedBy !== "system" ? `user (${updatedBy})` : "system"}.`;
                break;
        }

        if (description) {
            let activity = {};
            _.set(activity, "activityType.activityType", activityType);
            _.set(activity, "description.description", description);
            _.set(activity, "status", activityStatus);
            return activity;
        }
    }

    _normalizeActivity(activityEntity) {
        let activity;
        let activityType = activityEntity.getProperty("activityType");
        switch (activityType) {
            case "create":
                activity = this._normalizeCreateActivity(activityEntity);
                break;
            case "update":
                activity = this._normalizeUpdateActivity(activityEntity);
                break;
            case "relAdd":
                let createdBy = _.get(activityEntity, "createdBy", "unknown");
                activity = {};
                _.set(activity, "activityType.activityType", activityType);
                _.set(activity, "description.description", `File Started by (${createdBy}).`);
                _.set(activity, "status", "started");
                break;
        }
        if (!_.isEmpty(activity)) {
            let date = new Date(activityEntity.createdOn).toLocaleDateString() + " " + new Date(activityEntity.createdOn).toLocaleTimeString();

            _.set(activity, "snapshot.snapshot", date);
            _.set(activity, "id", activityEntity.id);
        }

        return activity;
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = BaseActivityViewColumnComponent;
